import { get } from 'lodash';
import { SANTA_MEMBERS_APP_ID } from '../../constants/members-area';
import { MY_POSTS_WIDGET_ID } from '../../constants/widgets';

const getCommunitiesContext = (state: any) => state.communitiesContext;

const getApplicationConfigFromContext = (communitiesContext: any, appDefinitionId: any) =>
  get(communitiesContext, appDefinitionId, {});

const getApplicationConfig = (state: any, appDefinitionId: any) =>
  getApplicationConfigFromContext(getCommunitiesContext(state), appDefinitionId);

export const getIsMemberAreaInstalled = (state: any) =>
  Boolean(getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled);

export const getIsMyPostsInstalled = (state: any) =>
  getIsMemberAreaInstalled(state) &&
  Boolean(getApplicationConfig(state, MY_POSTS_WIDGET_ID).isInstalled);
